(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const interval = setInterval(() => {
    const additionalCheckoutButtons = document.querySelector(
      '.additional-checkout-buttons.additional-checkout-buttons--vertical'
    );

    if (additionalCheckoutButtons) {
      additionalCheckoutButtons.style.display = 'none';
      additionalCheckoutButtons.setAttribute('aria-hidden', 'true');

      const focusable = additionalCheckoutButtons.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      focusable.forEach(function(el) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('disabled', 'disabled');
      });
    }
  }, 100);
});

  } catch(e) { console.error(e); }
})();
})();
